<template>
    <div class="supplier_basic">

        <v-container>
            <v-row>
                <v-col>
                    <!-- 
{{supplier.name}}{{supplier.systemCd}}

                    -->

                    <table>
                              
                        <tr>
                            <th>代表者</th>
                            <td>{{supplier.president}}</td>
                        </tr>            
                        <tr>
                            <th>URL</th>
                            <td>
                              <a v-if="supplier.url" :href="supplier.url" target="_blank">{{supplier.url}}</a>
                            </td>
                        </tr>
                        <tr>
                            <th>WEB会議</th>
                            <td>
                                <template v-for="a in supplier.applications" >
                                    <v-chip :key="a" v-if="a === 'teams'" small>Teams</v-chip>
                                    <v-chip :key="a" v-if="a === 'zoom'" small>Zoom</v-chip>
                                    <!--<v-chip :key="a" v-if="a === 'ggl'" small>GoogleMeet</v-chip>-->
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <th>売上比率</th>
                            <td><span v-if="!!supplier.salesShare">{{supplier.salesShare}}%</span></td>
                        </tr>
                        <tr>
                            <th>担当者</th>
                            <td>

                              <template v-for="rep in supplier.representatives">
                                  <span :key="rep.name">
                                    {{ rep.name }}
                                  </span>
                              </template>

                            </td>
                        </tr>
                        <tr>
                            <th>従業員数</th>
                            <td><span v-if="supplier.employeeNum">{{supplier.employeeNum}}人</span></td>
                        </tr>
                        <tr>
                            <th>資本金</th>
                          <td><span v-if="supplier.capital">{{supplier.capital}}万円</span></td>
                        </tr>
                        <tr>
                            <th>主要取引先</th>
                            <td>
                                <span v-for="cstm in supplier.clients" :key="cstm.name" class="mr-3">{{cstm.name}}</span>
                            </td>
                        </tr>
                        <tr>
                            <th>仕入先</th>
                            <td>
                                <span v-for="so in supplier.subSuppliers" :key="so.name" class="mr-3">{{so.name}}</span>
                            </td>
                        </tr>
                      <tr>
                        <th>取扱品目</th>
                        <td>
                          <template v-for="ig in supplier.itemGroups" >
                            <v-chip :key="ig" small>{{ getItemGroupName(ig) }}</v-chip>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>保有設備</th>
                        <td>
                          <template v-for="eq in supplier.equipments" >
                            <v-chip :key="eq" small>{{ getEquipmentName(eq) }}</v-chip>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <th>最終更新日</th>
                        <td> {{ this.formatDateToDisplay(supplier.updateAt) }} </td>
                      </tr>
                      <tr>
                        <th>最終更新者</th>
                        <td> {{ supplier.updateUserName }} </td>
                      </tr>

                    </table>
                </v-col>
            </v-row>

        </v-container>

    </div>
</template>
<script>
import ObjectParamSupport from "../../components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
import Template from "@/views/TheTemplate";


export default {
    mixins:[BaseView,ObjectParamSupport],
    components: {


    },
    props: {
        supplier: Object
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){
            let p = this.getObjectParam();
            if (p){
                // パラメータの転写
            }
        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(data => {
                        //
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

    },

}
</script>
<style lang="scss" scoped>
  .supplier_basic{

    table {
      tr {
        height: 2em;
      }
      th {
        padding-right: 1em;
      }

      .v-chip {
        margin-right: 3px;
      }

    }


  }

</style>